module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-02-70feef32b22d5b954268cba1c647a945.svg";